import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Reporting.css'
import reportingHero from "../../../assets/images/MIS Reporting.png";
import reportingDashboard from "../../../assets/images/MIS Reporting.png";

const ReportingPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> MIS Reporting – BuddyTech Solutions </title>
        <meta name="description" content="Automated and periodic reporting for sales, finance, HR and project performance." />
        <meta name="keywords" content="MIS reporting, KPI dashboards" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="MIS Reporting – BuddyTech Solutions" />
        <meta property="og:description" content="Automated and periodic reporting for sales, finance, HR and project performance." />
        <meta property="og:keywords" content="MIS reporting, KPI dashboards" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/mis/reporting" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="MIS Reporting – BuddyTech Solutions" />
        <meta name="twitter:description" content="Automated and periodic reporting for sales, finance, HR and project performance." />
        <meta name="twitter:keywords" content="MIS reporting, KPI dashboards" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="reporting-container">
        <header className="reporting-hero">
          <div className="reporting-hero-content">
            <h1>Business Reporting & Analytics</h1>
            <p>
              Our MIS reporting services turn raw data into actionable insights to drive informed decision-making and organizational efficiency.
            </p>
          </div>
          <img src={reportingHero} alt="Reporting Hero" className="reporting-hero-img" />
        </header>

        <section className="reporting-section">
          <div className="reporting-text">
            <h2>What We Deliver</h2>
            <p>
              We provide structured reporting systems and automated dashboards to help you visualize KPIs, track performance, and streamline operations.
            </p>
            <ul>
              <li>Daily, Weekly, Monthly Business Reports</li>
              <li>Automated Dashboard Integrations</li>
              <li>Excel, Google Sheets & Power BI Reports</li>
              <li>Sales, HR, Finance, and Project Metrics</li>
              <li>Custom Analytics for Data-Driven Decisions</li>
            </ul>
          </div>
          <img src={reportingDashboard} alt="Reporting Dashboard" className="reporting-img" />
        </section>

        <section className="reporting-tools">
          <h2>Tools & Platforms</h2>
          <div className="tools-grid">
            <span>Power BI</span>
            <span>Google Data Studio</span>
            <span>MS Excel</span>
            <span>Tableau</span>
            <span>Zoho Analytics</span>
            <span>Google Sheets</span>
            <span>Notion</span>
            <span>Grafana</span>
          </div>
        </section>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:Augustine.g.1992@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/917418763500" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+917418763500">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default ReportingPage;